import { useEffect } from 'react';
import { useApiContext } from 'react-easyrocket';
import { useSearchParams } from 'react-router';

export function useAccountSearchParam() {
  const [searchParams, setSearchParams] = useSearchParams();
  const account = searchParams.get('account');
  const { clearSession, saveSession } = useApiContext();

  useEffect(() => {
    if (account) {
      try {
        const decodedSession = atob(account);
        clearSession();
        saveSession(decodedSession);
        searchParams.delete('account');
        setSearchParams(searchParams);
      } catch {
        return;
      }
    }
  }, []);
}
